module.exports = __webpack_public_path__ + "img/kn13_samurai02skin_shop.fe6b3c02.png";